export default class FlightPeriod {
  title: string;
  startsAt: string;
  endsAt: string;
  draggable: boolean;
  resizable: boolean;
  arrivalDate: string;
  color: Object;
  actions: string[];
  $$hashKey: string;
  calendarEventId: number;
  company: string;
  flightNo: string | number;
  quota: string;
}
